class SignupContextBuilder {

    static getActiveExperiments() {
        if (window['optimizely'] && window['optimizely'].activeExperiments) {
            return window['optimizely'].activeExperiments;
        }
        return [];
    }

    static getVarationMapForExperiment(experimentId) {
        return window['optimizely'].data.state.variationMap[experimentId];
    }

    static getVariationIdForExperiment(experimentId, variationIndex) {
        return window['optimizely'].data.experiments[experimentId].variation_ids[variationIndex];
    }

    static getOptimizelyVariations() {
        const optimizelyExperiments = SignupContextBuilder.getActiveExperiments();
        return optimizelyExperiments.map(experimentId => {
            const variationIndex = SignupContextBuilder.getVarationMapForExperiment(experimentId);
            return SignupContextBuilder.getVariationIdForExperiment(experimentId, variationIndex);
        });
    }

    constructor() {
        const optimizelyVariations = SignupContextBuilder.getOptimizelyVariations();
        let metadata = [];

        return {
            withMetadata: function (metadataString) {
                if (typeof metadataString !== 'string') {
                    throw new Error('Unable to add metadata which is not a string');
                }
                metadata.push(metadataString);
                return this;
            },
            withMetadataArray: function (metadataArray) {
                for (const metadataItem of metadataArray) {
                    if (typeof metadataItem !== 'string') {
                        throw new Error('Unable to add metadata which is not a string');
                    }
                }
                metadata = metadata.concat(metadataArray);
                return this;
            },
            build: function () {
                const signupContext = {
                    'safeData': {
                        'optimizelyVariations': optimizelyVariations,
                        'metadata': metadata
                    },
                    'unsafeData': {}
                };
                return JSON.stringify(signupContext);
            }
        }
    }
}

module.exports = SignupContextBuilder;
